let avatarManagementEnv: string;
switch (process.env.ENV_TYPE) {
  case 'test':
  case 'dev':
  case 'stg':
    avatarManagementEnv = 'staging';
    break;
  default:
    avatarManagementEnv = 'prod';
    break;
}
const avatarManagementUrl = `https://avatar-management--avatars.us-west-2.${avatarManagementEnv}.public.atl-paas.net`;
const randomAvatarIndex = Math.floor(Math.random() * 7);

const DEFAULT_AVATAR_SUFFIX = '/default-avatar.png';

// The default site avatar served by settings-cdn-bifrost when a site has no
// custom avatar set.
export const DEFAULT_SITE_AVATAR_URL =
  'https://settings-cdn-bifrost.stg-east.frontend.public.atl-paas.net/assets/avatars/240/site.png';

function getInitials(name: string): string {
  return name
    .split(' ')
    .filter((word) => word.length > 0 && isNaN(Number.parseInt(word[0])))
    .slice(0, 2)
    .map((word) => word.at(0)?.toUpperCase())
    .join('');
}

export function getInitialAvatarURLFromName(name: string) {
  const initials = getInitials(name);
  return (
    (initials &&
      `${avatarManagementUrl}/initials/${initials}-${randomAvatarIndex}.png`) ||
    `${avatarManagementUrl}${DEFAULT_AVATAR_SUFFIX}`
  );
}

export function isDefaultAvatar(url: string): boolean {
  return url.endsWith(DEFAULT_AVATAR_SUFFIX);
}
